const settingCN = {
    SETTING_USER:'Setting',
    SETTING_COST:'Cost',
    SETTING_CHANGEINFO:'Change Info',
    SETTING_CHANGEPASSWORD:'Change Password',
    SETTING_COUNT:'Account Balance',
    SETTING_DEPOSIT:'Recharge Amount',
    SETTING_RECHARGE:'Recharge',
    SETTING_USED:'Used Amount',
    SETTING_CONTENT:'Content',
    SETTING_PRICE:'Price',
    SETTING_QUANTITY:'Quantity',
    SETTING_AMOUNT:'Money Amount',
    SETTING_DAILYLIMIT:'Daily Limit',
    SETTING_CHECKEDTIME:'Checked',
    SETTING_TIMELEFT:'Left',
    SETTING_BASICINFO:'Basic Infomation',
    SETTING_USERNAME:'UserName',
    SETTING_NICKNAME:'NickName',
    SETTING_COMPANYINFO:'Company Infomation',
    SETTING_COMPANYNAME:'Company Name',
    SETTING_LOCATION:'Location',
    SETTING_ZIP:'zip',
    SETTING_TARGETCOUNTRY:'Target Country',
    SETTING_COMPANYPRODUCT:'Company Product',
    SETTING_ORIGINPASSWORD:'Original Password',
    SETTING_NEWPASSWORD:'New Password',
    SETTING_CONFIRMPASSWORD:'Confirm Password',
    SETTING_PLEASE:'Please Enter',
    SETTING_TIPS:'Tips',
    SETTING_CONFIRMCHANGE:'Comfirm Change',
    SETTING_LOGIN:'Login',
    SETTING_FORGET:'Forget Password',
    SETTING_PASSWORD:'Password',
    SETTING_IDENTIFY:'Identify Code',
    SETTING_SENDEMAIL:'Send Email',
    SETTING_SIGNUP:'Sign Up',
    SETTING_NOW_PLAN:'Now Plan',
    SETTING_UPGRADE_PLAN:'Upgrade',
    SETTING_OTHER_FEE:'Cost out of plan',
    SETTING_LIMIT:'Plan quota'

}
export default settingCN


// WEBPACK FOOTER //
// ./src/lan/en/en_setting.js